import { Action, OperationType, Position, WindowType } from "puzzle";
import { APP_SETTINGS } from "puzzle/dispatcher/authentication/services/AuthSettings";
import ActiveSessions from "../components/Viewport/ActiveSessions/ActiveSessions";

export const selectionChange: Action = [{
  data: {
    filesInView: false,
    quotesInView: false
  },
  type: OperationType.data
}, {
  evaluate: true,
  executeType: 'visible',
  moduleName: '{currentModuleName}',
  name: 'gridOnSelectionChange',
  args: ['selectedSubmissions', 'forceOpenDrawer', 'quotesInView', 'filesInView'],
  type: OperationType.addOperationData
}, {
  name: 'updateDrawerState',
  type: OperationType.action
}, {
  items: ['selectedSubmissions'],
  type: OperationType.syncDispatchersDataItem
}];

export const openInEditModePrefilteredDashboard: Action = [{
  condition: '{closeSavedFilterDialog}',
  conditionOperations: [{
    name: 'closeDialog',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  name: 'openEditFilterDialog',
  type: OperationType.action
}, {
  name: 'getSearchBarData',
  type: OperationType.action
}];

export const openPrefilteredSubmissionList: Action = [{
  data: {
    template: {
      withRefresh: false
    }
  },
  moduleName: 'MainGrid',
  name: 'clearFilter',
  args: ['withRefresh']
}, {
  name: 'checkboxSelectionClear',
  type: OperationType.action
}, {
  condition: '{closeSavedFilterDialog}',
  conditionOperations: [{
    name: 'closeDialog',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  condition: '{path}',
  conditionOperations: [{
    moduleName: 'App',
    type: OperationType.redirect
  }],
  type: OperationType.conditional
}, {
  condition: '{decodeFilter}',
  conditionOperations: [{
    moduleName: 'SearchBar',
    name: 'prepareDataForSearch',
    args: ['filter'],
    mappingName: 'mainGridFilter',
    waitForModule: true,
    type: OperationType.addOperationData
  }, {
    moduleName: 'SearchBar',
    name: 'decodeEditData',
    args: ['filter'],
    mappingName: 'filter',
    waitForModule: true,
    type: OperationType.addOperationData
  }, {
    moduleName: 'SearchBar',
    name: 'addFilterToState',
    args: ['filter'],
    waitForModule: true,
    type: OperationType.addOperationData
  }],
  elseOperations: [{
    moduleName: 'SearchBar',
    name: 'addFilterToState',
    args: ['filter'],
    waitForModule: true,
    type: OperationType.addOperationData
  }, {
    moduleName: 'SearchBar',
    name: 'prepareDataForSearch',
    args: ['filter'],
    type: OperationType.addOperationData,
    mappingName: 'mainGridFilter'
  }],
  type: OperationType.conditional
}, {
  persistent: ['mainGridFilter'],
  type: OperationType.addPersistentData
}, {
  moduleName: 'NavigationGrid',
  name: 'resetGridData'
}, {
  name: 'reloadSubmissionList',
  type: OperationType.action
}];

export const closeDrawer: Action = [{
  condition: '{route() === "view/taskList"}',
  conditionOperations: [{
    moduleName: 'TaskList',
    name: 'closeDrawer'
  }],
  type: OperationType.conditional
}, {
  condition: '{route() === "view/submissionList"}',
  conditionOperations: [{
    moduleName: 'SubmissionsList',
    name: 'closeDrawer'
  }],
  type: OperationType.conditional,
}];

export const closeDetachedDrawer: Action = [{
  type: OperationType.data,
  data: {
    attachDrawer: false
  }
}, {
  moduleName: 'SubmissionsList',
  args: ['attachDrawer'],
  name: 'newWindowUnloaded'
}];

export const selectionChangeWithToolbarUpdate: Action = [{
  name: 'selectionChangeToolbar',
  type: OperationType.action
}, {
  name: 'selectionChange',
  type: OperationType.action
}, {
  name: 'openDrawerFromDashboard',
  args: ['forceOpenDrawer', 'selectedSubmissions'],
  type: OperationType.action
}, {
  condition: '{calledFromNotesOrInstructionIcon}',
  conditionOperations: [{
    waitForModule: true,
    moduleName: 'DrawerContent',
    name: 'changeTab',
    args: ['tab', 'filters', 'openNotes']
  }],
  type: OperationType.conditional
}];


export const openDrawerFromDashboard: Action = [{
  condition: '{route() === "view/dashboard"} && {forceOpenDrawer}',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          submissionData: '{selectedSubmissions[0]}'
        }
      }
    },
    type: OperationType.data
  }, {
    moduleName: 'Dashboard',
    name: 'prepareFilterData',
    args: ['submissionData'],
    type: OperationType.addOperationData
  }, {
    data: {
      template: {
        decodeFilter: true,
        path: '/view/submissionList',
        filter: {
          bind: {
            searchData: '{prepareFilterData}'
          }
        }
      }
    },
    type: OperationType.data
  }, {
    name: 'openPrefilteredSubmissionList',
    type: OperationType.action
  }, {
    moduleName: 'NavigationGrid',
    name: 'selectFirst'
  }, {
    name: 'selectionChange',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const selectionChangeToolbar: Action = [{
  condition: '_.includes(["view/taskList", "view/submissionList"], {route()})',
  conditionOperations: [{
    moduleName: 'ActionToolbar',
    name: 'menageState',
    args: ['selectedSubmissions'],
  }],
  type: OperationType.conditional
}, {
  items: ['selectedSubmissions'],
  type: OperationType.syncDispatchersDataItem
}, {
  persistent: ['selectedSubmissions'],
  type: OperationType.addPersistentData
}];

export const userPromise: Action = [{
  isCallback: false,
  isPromise: true,
  mappingName: 'userPromise',
  moduleName: 'AuthService',
  name: 'getUser'
}, {
  condition: '{userPromise}',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          userName: `_.get({userPromise}, 'profile.sub') || _.get({initializeUserData}, "userProfile.userInfo.userName")`
        }
      }
    },
    type: OperationType.data
  }, {
    condition: '{userName}',
    conditionOperations: [{
      condition: '{route()} === "view/dashboard"',
      conditionOperations: [{
        args: ['userName'],
        moduleName: 'Dashboard',
        name: 'setUserName'
      }],
      type: OperationType.conditional
    }],
    elseOperations: [{
      moduleName: 'Header',
      name: 'initialData'
    }],
    type: OperationType.conditional
  }],
  elseOperations: [{
    independent: true,
    data: {
      forceRefresh: true,
      path: APP_SETTINGS.login_uri
    },
    type: OperationType.redirect
  }],
  type: OperationType.conditional
}];

export const openActiveSessionsDialog: Action = [{
  data: {
    method: 'get',
    url: '/user/sessions',
  },
  mappingName: 'sessionsData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        sessionsCount: '{sessionsData.userSessions.length}'
      }
    }
  },
  type: OperationType.data
}, {
  args: ['sessionsCount'],
  moduleName: 'Footer',
  name: 'setNumberOfActiveSessions'
}, {
  className: 'active-session lg',
  children: [{
    render: ActiveSessions,
    propArgs: ['sessionsData']
  }],
  items: [{
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }],
    btnName: 'activeSessions.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      data: {
        method: 'post',
        url: '/user/sessions',
      },
      type: OperationType.request
    }, {
      data: {
        template: {
          bind: {
            sessionsCount: 1
          }
        }
      },
      type: OperationType.data
    }, {
      args: ['sessionsCount'],
      moduleName: 'Footer',
      name: 'setNumberOfActiveSessions'
    }, {
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }],
    btnName: 'activeSessions.signOut',
    close: false,
    btnConfig: {
      accessibility: {
        ariaLabel: '',
        iconAriaHidden: true
      },
      themeColor: 'error',
      pos: Position.end
    }
  }],
  // className: '',
  title: 'activeSessions.title',
  type: OperationType.dialog
}];

/**
 * Updates drawerState detached property
 */
export const updateDrawerDetachedState: Action = [{
  data: {
    update: {
      drawerState: {
        bind: {
          detached: '{detached}'
        }
      }
    }
  },
  type: OperationType.data
}];

/**
 * Refreshes MainGrid/Task grid and performs refresh on drawer
 */
export const refreshAppFromMainGrid: Action = [{
  condition: '_.get({drawerState}, "detached")',
  conditionOperations: [{
    name: 'refreshMainGridOnCurrentPosition',
    type: OperationType.action
  }, {
    moduleName: 'ToastNotifications',
    moduleId: 'ToastNotificationsViewport',
    name: 'refreshChildPopupByPushMessage'
  }],
  elseOperations: [{
    name: 'refreshMainGridOnCurrentPosition',
    type: OperationType.action
  }, {
    data: {
      template: {
        mountedModuleName: 'DrawerContent'
      }
    },
    moduleName: 'ActionExecutor',
    name: 'getAppModule',
    mappingName: 'isModuleMounted',
    args: ['mountedModuleName'],
    type: OperationType.addOperationData
  }, {
    condition: '{isModuleMounted}',
    conditionOperations: [{
      name: 'refreshDrawerTab',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

/**
 * If drawer is detached performs refresh main grid via postMessage.
 * In case of attached drawer refreshes files tab + main grid regular way.
 */
export const refreshGridsByPostMessage: Action = [{
  condition: '_.get({drawerState}, "detached")',
  conditionOperations: [{
    moduleName: 'ToastNotifications',
    moduleId: 'ToastNotificationsDrawer',
    name: 'refreshMainGridByPushMessage'
  }, {
    name: 'refreshFilesGrid',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'refreshFilesGridToCurrentPosition',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

/**
 * Refreshes currently selected drawer tab
 */
export const refreshDrawerTab: Action = [{
  moduleName: 'DrawerContent',
  name: 'getSelectedTab',
  mappingName: 'selectedTab',
  type: OperationType.addOperationData
}, {
  condition: '{selectedTab}', // other drawer tabs can also be added here
  DETAILS: [{
    moduleName: 'SubmissionDetails',
    name: 'reloadDetails'
  }],
  FILES: [{
    moduleName: 'App',
    type: OperationType.maskModule
  }, {
    name: 'refreshFilesGrid',
    type: OperationType.action
  }, {
    moduleName: 'App',
    type: OperationType.unmaskModule
  }],
  QUOTES: [{
    moduleName: 'QuotesReview',
    name: 'getData'
  }],
  STATUS: [{
    moduleName: 'SubmissionStatus',
    name: 'loadTabData'
  }],
  SUPPLEMENTARY_FILES: [{
    moduleName: 'SupplementaryFiles',
    name: 'requestSupplementaryData'
  }],
  type: OperationType.switch
}];

/**
 * Add appDetachedWindow to detachedDrawer Dispatcher instance.
 */
export const registerAsDetachedWindow: Action = [{
  data: {
    template: {
      appDetachedWindow: true
    }
  },
  persistent: ['appDetachedWindow'],
  type: OperationType.addPersistentData
}];

/**
 * Performs refresh on main grid and conditionally on drawer (attached or detached)
 */
export const refreshApp: Action = [{
  condition: '{appDetachedWindow}', // if appDetachedWindow is true that means that action is performed from detached window!
  conditionOperations: [{
    name: 'refreshGridsByPostMessage',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'refreshAppFromMainGrid',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

/**
 * Performs refresh on dashboard refresh button click. It also updates filters.
 */
export const refreshAppAndFilters: Action = [{
  name: 'refreshApp',
  type: OperationType.action
}, {
  name: 'getFavoriteFilters',
  type: OperationType.action
}];

export const changeDrawerTab: Action = [{
  data: {
    template: {
      event: {
        bind: {
          selected: '{tabIndex}'
        }
      }
    },
    filesFilter: {},
    openedFromNotes: false
  },
  args: ['event', 'filesFilter', 'openedFromNotes'],
  moduleName: 'DrawerContent',
  name: 'changeTab'
}, {
  persistent: ['tabIndex'],
  type: OperationType.removePersistentData
}];